/**
 * Black Friday Banner - Click to Copy Discount Code
 * Copies "XMAS25" to clipboard and shows confirmation message
 */

document.addEventListener('DOMContentLoaded', function() {
  const banner = document.querySelector('.template-product .am-campaign-pill');
  
  if (!banner) return;
  
  // Store original text
  const originalText = banner.textContent;
  
  banner.addEventListener('click', function() {
    // Copy code to clipboard
    const code = 'MAMBO15';
    
    // Modern clipboard API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function() {
        showCopiedMessage();
      }).catch(function(err) {
        // Fallback if clipboard API fails
        fallbackCopyTextToClipboard(code);
      });
    } else {
      // Fallback for older browsers
      fallbackCopyTextToClipboard(code);
    }
  });
  
  function showCopiedMessage() {
    // Change banner text to show confirmation
    banner.textContent = 'Code MAMBO15 copied!';
    banner.style.backgroundColor = 'C98773'; 
    
    // Reset after 2 seconds
    setTimeout(function() {
      banner.textContent = originalText;
      banner.style.backgroundColor = '#E8818F'; // Back to black
    }, 2000);
  }
  
  function fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = '0';
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        showCopiedMessage();
      }
    } catch (err) {
      console.error('Fallback: Could not copy text', err);
    }
    
    document.body.removeChild(textArea);
  }
});
